<router-outlet></router-outlet>
<app-notification class="z-50"></app-notification>
<app-report-banner></app-report-banner>
